import React, { useEffect, useState } from 'react'
import { Input, InputGroup, Loader } from 'rsuite'
import styled from 'styled-components'

import {
  HorizontalFlex, VerticalFlex, BackButton, H1,
  Title, VideoFrame, PhotoFrame, P2, EditButton,
  AutosaveTime
} from './ActivityStyledComponents'
import { ActivitiesFav, Undo } from '../Icons'
import BriefDescriptionList from './BriefDescriptionList'
import Guidelines from './Guidelines'
import { colors } from '../Styles/common-styles'

const WrappedUndo = styled.div`
  float: right;
  cursor: pointer;
  transform: rotate(0deg);
  overflow: hidden;
  transition: all 0.3s ease-out;
  transform: ${props => (props.rotate ? 'rotate(360deg)' : '')};
`

const styles = {
  topic: {
    width: 318,
    marginLeft: 33
  },
  modify: {
    minHeight: 77,
    width: '100%',
    wordWrap: 'break-word'
  },
  instructions: {
    margin: 0,
    textAlign: 'left',
    marginTop: '58px',
    input: {
      marginTop: '12px',
      minHeight: 130
    }
  }
}

const SaveTime = ({ time }) => {
  const [fakeCurrentDate, setFakeCurrentDate] = useState(new Date())
  const [rotated, setRotated] = useState(false)

  useEffect(() => {
    let mounted = true
    if (mounted) {
      setTimeout(() => setFakeCurrentDate(new Date()), 60000)
    }
    return function cleanup () {
      mounted = false
    }
  }, [fakeCurrentDate])

  const formateDate = date => {
    const minutes = parseInt(date / 60000)
    if (minutes === 0) {
      return 'few seconds ago'
    } else if (minutes <= 59) {
      return `${minutes} minute(-s) ago`
    } else if (minutes > 59 && minutes < 1440) {
      return `${minutes / 60} hour(-s) ago`
    } else {
      return 'long ago'
    }
  }
  return (
    <div style={{ display: 'flex', alignItems: 'center', paddingRight: 20 }}>
      <AutosaveTime style={{ marginRight: 25 }}>
        Autosaved &nbsp;
        {formateDate(fakeCurrentDate - time)}
      </AutosaveTime>

      <WrappedUndo
        rotate={rotated}
        onClick={() => setRotated(!rotated)}
      >
        <Undo />
      </WrappedUndo>
    </div>
  )
}

const EditActivity = ({
  setActivityPreviewModal, isFav, videoId, image, event, setEvent, data, phaseIndex
}) => {
  const [showDescription, setShowDescription] = useState(true)
  const [modifyGoals, setModifyGoals] = useState(false)
  const [newGoals, setNewGoals] = useState(!data?.data.goals.length ? '' : data.data.goals[0].text)
  const [modifyPreparation, setModifyPreparation] = useState(false)
  const [newPrep, setNewPrep] = useState(!data?.data?.preparation.length ? '' : data.data.preparation[0].text)
  const [instructions, setInstructions] = useState(!data.data.instructions ? '' : data.data.instructions)
  const [topic, setTopic] = useState(!data.data.topic ? '' : data?.data?.topic)
  const [addInstructions, setAddInstructions] = useState(!!data.data.instructions)
  const [saveTime, setSaveTime] = useState(new Date())
  const cardData = !data.data ? null : data.data
  console.log(event.phases[phaseIndex].data)
  useEffect(() => {
    if (topic) {
      event.phases[phaseIndex].data[data.index].topic = topic
      setEvent({ ...event })
    }
  }, [topic])

  useEffect(() => {
    if (newPrep) {
      if (!event.phases[phaseIndex].data[data.index].preparation.length) {
        event.phases[phaseIndex].data[data.index].preparation.push({ text: newPrep })
      }
      event.phases[phaseIndex].data[data.index].preparation[0].text = newPrep
      setEvent({ ...event })
    }
  }, [newPrep])

  useEffect(() => {
    if (newGoals) {
      if (!event.phases[phaseIndex].data[data.index].goals.length) {
        console.log('here')
        event.phases[phaseIndex].data[data.index].goals[0].text = newGoals
      }
      event.phases[phaseIndex].data[data.index].goals[0].text = newGoals
      setEvent({ ...event })
    }
  }, [newGoals])

  useEffect(() => {
    if (instructions) {
      event.phases[phaseIndex].data[data.index].instructions = instructions
      setEvent({ ...event })
    }
  }, [instructions])

  return (
    <div style={{ marginLeft: '49px' }}>
      {cardData !== null &&
        <VerticalFlex
          onClick={() => {
            setModifyGoals(false)
            setModifyPreparation(false)
            setAddInstructions(false)
            setSaveTime(new Date())
          }}
        >
          <BackButton
            style={{ margin: '14px 0', display: 'flex', width: '170px' }}
            onClick={
              () => setActivityPreviewModal(false)
            }
          > &#8592; Back to my event</BackButton>
          <div style={{ marginTop: '9px', marginBottom: '22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <P2>Topic:</P2>
              <InputGroup inside style={styles.topic} onClick={e => e.stopPropagation()}>
                <Input
                  placeholder='e.g. Discussing today’s agenda'
                  value={topic}
                  onChange={setTopic}
                />
              </InputGroup>
            </div>
            <SaveTime time={saveTime} />
          </div>

          <HorizontalFlex>
            <VerticalFlex>
              {videoId
                ? <VideoFrame src={`https://www.youtube.com/embed/${videoId}?feature=oembed}`} />
                : image && <PhotoFrame src={image} />}
              {!cardData ? null : <BriefDescriptionList
                cardDataBriefDescription={cardData}
              />}
              {cardData?.data?.instructions || addInstructions
                ? <div style={styles.instructions}>
                  <P2>Participant's instructions</P2>
                  <InputGroup inside style={styles.instructions.input} onClick={e => e.stopPropagation()}>
                    <Input
                      componentClass='textarea'
                      placeholder='e.g. Prepare presentation'
                      value={instructions}
                      onChange={setInstructions}
                    />
                  </InputGroup>
                </div>
                : <>
                  <HorizontalFlex style={{ marginTop: '58px' }}>
                    {instructions
                      ? <P2
                        style={{ margin: 0, textAlign: 'left', marginRight: '28px' }}
                      >Participant's instructions</P2> : ''}
                    <EditButton
                      style={{ margin: 0, textAlign: 'left' }}
                      onClick={e => {
                        e.stopPropagation()
                        setAddInstructions(!addInstructions)
                      }}
                    > {instructions ? 'Modify' : '+ Add participant´s instructions '}

                    </EditButton>
                  </HorizontalFlex>
                  <div style={styles.instructions} style={{ width: '370px', marginTop: '18px' }}>
                    <P2> {instructions}</P2>
                  </div>
                </>}
            </VerticalFlex>

            <VerticalFlex style={{ width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', paddingLeft: 20 }}>
                <ActivitiesFav
                  fill={isFav ? colors.orange : colors.grey}
                />
                <Title>{cardData?.title[0]?.text || ''}</Title>
              </div>
              <>
                {cardData?.description[0]
                  ? <div style={{ padding: '0 20px', marginTop: '18px' }}>
                    <div style={{ display: 'flex', marginBottom: '8px' }}>
                      <H1>Description</H1>
                      <EditButton
                        onClick={e => {
                          e.stopPropagation()
                          setShowDescription(!showDescription)
                        }}
                      >
                        {showDescription ? 'Hide' : 'Show'}
                      </EditButton>
                    </div>
                    {showDescription && cardData?.description.map((description, index) => {
                      return (
                        <P2 key={index}>{description.text}</P2>
                      )
                    })}
                  </div>
                  : ''}
                <div style={{ padding: '0 20px', marginTop: '18px' }}>
                  <div style={{ display: 'flex', marginBottom: '8px' }}>
                    <H1>Goals</H1>
                    <EditButton
                      onClick={e => {
                        e.stopPropagation()
                        setModifyGoals(!modifyGoals)
                      }}
                    >Modify</EditButton>
                  </div>
                  {modifyGoals
                    ? <InputGroup inside style={styles.modify} onClick={e => e.stopPropagation()}>
                      <Input
                        componentClass='textarea'
                        value={newGoals}
                        onChange={setNewGoals}
                        // onPressEnter={onSubmit}
                      />
                    </InputGroup>
                    : <P2> {newGoals}</P2>}
                </div>
                <div style={{ padding: '0 20px', marginTop: '18px' }}>
                  <H1>Tools</H1>
                  {cardData?.requisites.map((tool, index) => {
                    return (
                      <P2 key={index}> {tool.text}</P2>
                    )
                  })}
                </div>

                <div style={{ padding: '0 20px', marginTop: '18px' }}>
                  <div style={{ display: 'flex', marginBottom: '8px' }}>
                    <H1>Preparation</H1>
                    <EditButton
                      onClick={e => {
                        e.stopPropagation()
                        setModifyPreparation(!modifyPreparation)
                      }}
                    >Modify</EditButton>
                  </div>
                  {modifyPreparation
                    ? <InputGroup inside style={styles.modify} onClick={e => e.stopPropagation()}>
                      <Input
                        componentClass='textarea'
                        value={newPrep}
                        onChange={setNewPrep}
                        // onPressEnter={onSubmit}
                      />
                    </InputGroup>
                    : cardData?.preparation.map((prep, index) => {
                      return (
                        <P2 key={index}> {prep.text}</P2>
                      )
                    })}
                </div>
              </>
              <div style={{ marginTop: '58px' }}>
                <Guidelines
                  cardDataSteps={cardData?.steps}
                />
              </div>
            </VerticalFlex>
          </HorizontalFlex>
        </VerticalFlex>}
      {cardData === null &&
        <Loader backdrop size='lg' content='loading...' vertical />}
    </div>
  )
}

export default EditActivity
